module.exports = __webpack_public_path__ + "img/logo-instagram.9cc8ba01.svg";